import HttpService from './HttpService';

class CookieHistoricoService extends HttpService {
  /**
   * Endpoint vive no backend `meu-acerto-cookies`, hospedado fora do domínio
   * do backend "portal" (`VUE_APP_API_PORTAL_BASE_URL`) — daí a baseURL dedicada.
   */
  registrarAceite() {
    return this.post<void>(
      '/api/cookies/historicocookie',
      { aceito: true },
      {
        baseURL: appSettings.VUE_APP_URL_API_COOKIES,
      }
    );
  }
}

const cookieHistoricoService = new CookieHistoricoService();
export default cookieHistoricoService;
